export default __webpack_public_path__ + "static/2-a93eb4475f1e56f55e0589a823499e36.png";